import axios from 'axios';

// ─── DTOs e interfaces ─────────────────────────────────────────────────────────

export interface KitListItem {
  id: string;
  codigo: number;
  descricao: string;
  precoKit: number;
  inativo: boolean;
  qtdComponentes: number;
}

export interface KitComponenteDetalhe {
  componenteProdutoId: string;
  codigo: number;
  descricao: string;
  quantidade: number;
  precoNoKit: number;
  custoUnitario: number;
  vendaUnitario: number;
}

export interface KitDetalhe {
  id: string;
  codigo: number;
  descricao: string;
  precoKit: number;
  inativo: boolean;
  componentes: KitComponenteDetalhe[];
}

export interface KitComponenteDto {
  componenteProdutoId: string;
  quantidade: number;
  precoNoKit: number;
}

export interface SalvarKitDto {
  descricao: string;
  precoKit: number;
  inativo: boolean;
  componentes: KitComponenteDto[];
}

// ─── Service ───────────────────────────────────────────────────────────────────

export const kitService = {
  async listar(termo?: string): Promise<KitListItem[]> {
    const response = await axios.get<KitListItem[]>('/api/kits', {
      params: { termo },
    });
    return response.data;
  },

  async obter(id: string): Promise<KitDetalhe> {
    const response = await axios.get<KitDetalhe>(`/api/kits/${id}`);
    return response.data;
  },

  async criar(data: SalvarKitDto): Promise<{ id: string; codigo: number }> {
    const response = await axios.post<{ id: string; codigo: number }>('/api/kits', data);
    return response.data;
  },

  async alterar(id: string, data: SalvarKitDto): Promise<void> {
    await axios.put(`/api/kits/${id}`, data);
  },

  async remover(id: string): Promise<void> {
    await axios.delete(`/api/kits/${id}`);
  },
};
